import React, { Component }    from 'react';
import { withRouter }          from 'react-router';
import { connect }             from 'react-redux';
import { Form, Badge }         from 'react-bootstrap';
import { ClipLoader }          from 'react-spinners';
import { TestConstants }       from '../environment';
import { initiativeFetchData } from '../../../../actions/test-maintenance/initiative';

var apiHost = TestConstants.WebApiHost;

class TestInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      payload: ''
    };
    
    this.testInitiative  = this.testInitiative.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }
  
  testInitiative(e) {
    e.preventDefault();
    e.stopPropagation();
    var form = new FormData(e.currentTarget);
    if (e.currentTarget.checkValidity() !== false) {
      var users = form.get("Users");
      var split = users.split("\n");
      if (users.indexOf('\r') > -1) {
        split = users.split("\r\n");
      }
      
      this.props.fetchData(apiHost, { Users: split });
    }
  }
  
  copyToClipboard() {
    var value = '';
    for (var i = 0; i < this.props.initiative.Result.length; i++) {
      value = value + this.props.initiative.Result[i] + "\r\n";
    }
    
    var tempInput = document.createElement("textarea");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  }

  render() {
    return (
      <div>
        <Form onSubmit={this.testInitiative}>
          <Form.Group>
            <Form.Label>Test Initiative Users</Form.Label>
            <Form.Control name="Users" as="textarea" rows="10" placeholder="Test Initiative Users" required />
            <span className="text">
              Please include employee IDs one per line.
            </span>
          </Form.Group>
          <button type='submit' className="c-btn c-btn--sm" style={{ width: '100%', lineHeight: 0, marginTop: '10px', marginBottom: '10px' }}>
            <span className="c-btn__text">Submit</span>
          </button>
        </Form> 
        { this.props.initiativeHasErrored && !this.props.initiativeIsLoading ?
          <Badge style={{ fontSize: '18px' }} title='Error' variant="danger">An error occurred, please make sure all entries are valid</Badge>
          
          :
          <span></span>
        }
        { !this.props.initiativeHasErrored && !this.props.initiativeIsLoading && this.props.initiative.Result ?
          <a onClick={this.copyToClipboard} href="/#/test-maintenance/admin/initiative"><Badge style={{ fontSize: '18px' }} title='Copy to Clipboard' variant="success">Copy to Clipboard</Badge></a>
          :
          <span></span>
        }
        { this.props.initiativeIsLoading ?
          <ClipLoader
            color={'#072659'} 
            loading={this.props.chatIsLoading} 
          />
          :
          <span></span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    initiative: state.testM.initiative.initiative,
    initiativeHasErrored: state.testM.initiative.initiativeHasErrored,
    initiativeIsLoading: state.testM.initiative.initiativeIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, params) => dispatch(initiativeFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TestInitiative));
